/**
 * StyleUtil className
 */
export const StyleUtil = {
  container: 'w-full px-12 py-[calc(2vh+40px)]',
  containerNoScroll: 'w-full h-full px-12 py-[calc(2vh+40px)] overflow-hidden',
  headline: 'mentem-headline',
  headlineSmall: 'mentem-headline-small',
  // deprecated
  buttonPrimary:
    'mentem-button bg-primary border-primary btn hover:text-[#3C415D] hover:bg-white hover:border-[#D5D5DB]',
  buttonSecondary:
    'mentem-button text-[#3C415D] bg-white border-[#D5D5DB] btn hover:text-white hover:bg-primary hover:border-primary',
  buttonPrimaryReadOnly:
    'mentem-button text-white bg-primary border-primary btn-sm btn rounded-3xl shadow-lg cursor-default',
  buttonSecondaryReadOnly:
    'mentem-button text-[#3C415D] bg-white border-[#D5D5DB] btn-sm btn rounded-3xl shadow-lg cursor-default',
  buttonRejected:
    'mentem-button text-black bg-redHighlight border-redHighlight btn hover:bg-black hover:text-white hover:border-black',
  buttonApproved:
    'mentem-button text-black bg-[#1AC987] border-[#1AC987] btn hover:bg-black hover:text-white hover:border-black',
  buttonPurple:
    'mentem-button bg-purple text-white border-purple btn hover:text-black hover:bg-white hover:border-black',
  buttonGrey:
    'mentem-button bg-primaryGrey text-white border-primaryGrey btn hover:text-black hover:bg-white hover:border-black',
  buttonPurpleSecondary:
    'mentem-button text-[#3C415D] bg-white border-[#D5D5DB] btn hover:text-white hover:bg-purple hover:border-purple',
  buttonPrimaryUnsw:
    'mentem-button text-black bg-primaryUnsw border-primaryUnsw btn hover:bg-[#F1D000] hover:border-black',
  buttonSecondaryUnsw:
    'mentem-button text-[#3C415D] bg-white border-[#D5D5DB] btn hover:text-black hover:bg-primaryUnsw hover:border-primaryUnsw',
  buttonPrimaryDisabled:
    'mentem-button bg-[#949494] text-white border-[#949494] btn hover:text-[#3C415D] hover:bg-white hover:border-[#D5D5DB]',
  buttonTertiary:
    'mentem-button text-white bg-red-500 border-red-500 btn hover:text-[#3C415D] hover:bg-white hover:border-[#D5D5DB]',

  buttonBlackWhite:
    'mentem-button text-black bg-white border-black btn hover:text-white hover:bg-black hover:border-black',
  buttonBlackWhiteDisabled:
    'mentem-button text-black bg-white border-black btn',
  buttonPrimarySection:
    'mentem-button text-white bg-primary border-primary btn hover:text-white hover:bg-primary hover:border-primary',
  buttonSecondarySection:
    'mentem-button text-[#3C415D] bg-white border-[#D5D5DB] btn hover:text-white hover:bg-primary hover:border-primary',
  inputSearch:
    'text-sm font-normal w-full py-2 px-2 pl-4 rounded-3xl border border-solid border-[#D5D5DB] bg-transparent bg-clip-padding text-black outline-none shadow-lg font-roboto',
  inputSearchWithIcon:
    'text-sm font-normal w-full py-2 px-2 pl-10 rounded-3xl border border-solid border-neutral-300 bg-transparent bg-clip-padding text-black outline-none shadow-lg font-roboto',
  dropDownSearch:
    'w-full max-w-md absolute z-50 mt-9 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none',
  stickyTableHeader1: 'sticky top-0 z-1 mentem-table-header-1',
  stickyTableHeader2: 'sticky top-0 z-1 mentem-table-header-2',
}
// className="arch-add-input w-full border-[1px] p-[7px] font-roboto"
